// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Subaccounts_AsaasTriggerInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Subaccounts_AsaasTriggerInput — body for POST /subaccounts/webhooks/asaas-staff.
 *
 * The DEV-ONLY staff trigger that synthesizes an ASAAS payment event for a
 * charge that is already pending in our books, so the confirm/refuse half of
 * the ASAAS lane can be exercised without ASAAS actually moving money.
 *
 * WHY THE VOCABULARY IS ASAAS'S, NOT OURS. The synthesized payload is fed to
 * AsaasPlatformGateway::normalizeEvent() — the very same normalizer a real
 * inbound webhook goes through. Accepting our own internal event names here
 * would mean translating them into ASAAS's on the way in, and that translation
 * would be code the real webhook never runs. So the trigger speaks ASAAS:
 * whatever `event` ASAAS would put on the wire is what goes in this field.
 *
 * EVENTS. Deliberately only the payment events the adapter actually maps, and
 * only those reachable from a pending charge:
 *   PAYMENT_CONFIRMED / PAYMENT_RECEIVED  — the money arrived
 *   PAYMENT_OVERDUE                       — it did not
 *   PAYMENT_REFUNDED / PAYMENT_DELETED    — the charge died (one-off only;
 *                                           ignored on a subscription cycle,
 *                                           by the adapter's own rule)
 * SUBSCRIPTION_* events are NOT accepted: this trigger is reached from a
 * transaction, and a transaction is a charge. The subscription lifecycle has
 * its own surfaces.
 *
 * NOT AN INPUT: the subscription id. A real ASAAS cycle payment carries
 * `payment.subscription`, and whether it is present is the DISCRIMINATOR the
 * adapter branches on (cycle vs standalone credit purchase). Letting the caller
 * supply it would let a browser decide which of two different service paths
 * runs. The server resolves it from the charge id instead — see
 * Webhooks::asaas_staff().
 */
import { registerContract } from './validate'

export interface Subaccounts_AsaasTriggerInput {
event_type: string
charge_id: string
value_cents?: number
paid_at?: string
external_reference?: string
}

registerContract('Subaccounts_AsaasTriggerInput', {
  event_type:         { type: 'string',  required: true },
  charge_id:          { type: 'string',  required: true },
  value_cents:        { type: 'number',  required: false },
  paid_at:            { type: 'string',  required: false },
  external_reference: { type: 'string',  required: false },
})
